// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202602201702/js/" + chunkId + "." + {"44":"8db44613","225":"d402a1a3","481":"eda4b99a","486":"e3d0ae73","770":"3e166e0d"}[chunkId] + ".0.9591177957218517.chunk.js";
};